import { useAppState } from 'hooks/useAppState';

export const useEmployeeToEdit = () => {
  const { employeeToEdit } = useAppState();
  return employeeToEdit;
};
